import { moreThanThreeCardsSwiper } from '@sections/article_list/more_than_three_cards/swiper';
import { threeCardsSwiper } from '@sections/article_list/three_cards/swiper';

// Trigger the correct swiper js if we are on 3 cards view or more than 3 cards view.
document.addEventListener("DOMContentLoaded", function(_event) {
  if (document.getElementsByClassName('swiper-article-list-three-cards').length > 0) {
    threeCardsSwiper();
  } else if (document.getElementsByClassName('swiper-article-list-more-than-three-cards').length > 0) {
    moreThanThreeCardsSwiper;
  }
});
